import { render, staticRenderFns } from "./VehicleContractForReportWidget.vue?vue&type=template&id=37f3a01a&scoped=true&"
import script from "./VehicleContractForReportWidget.vue?vue&type=script&lang=js&"
export * from "./VehicleContractForReportWidget.vue?vue&type=script&lang=js&"
import style0 from "./VehicleContractForReportWidget.vue?vue&type=style&index=0&id=37f3a01a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f3a01a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f3a01a')) {
      api.createRecord('37f3a01a', component.options)
    } else {
      api.reload('37f3a01a', component.options)
    }
    module.hot.accept("./VehicleContractForReportWidget.vue?vue&type=template&id=37f3a01a&scoped=true&", function () {
      api.rerender('37f3a01a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/VehicleContractForReportWidget.vue"
export default component.exports